import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  ListItem,
  Box,
  ListItemText,
  Grid,
  AccordionSummary,
  Accordion,
  Typography,
  AccordionDetails,
  List,
  IconButton,
  Menu,
  MenuItem,
  Chip,
  ButtonBase,
} from "@material-ui/core";

import * as React from "react";
import CheckIcon from "@material-ui/icons/Check";
import CrossIcon from "@material-ui/icons/Close";
import YESMoodGoodIcon from "@material-ui/icons/Mood";
import NOMoodBadIcon from "@material-ui/icons/MoodBad";
import CommentIcon from "@material-ui/icons/Comment";
import ThumbsUpIcon from "@material-ui/icons/ThumbUp";
import ThumbsDownIcon from "@material-ui/icons/ThumbDown";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DigitsIcon from "@material-ui/icons/Dialpad";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import pointRightFinger from "../assets/images/finger.png";
import imagePlacholder from "../assets/images/image-placeholder.png";
import ResponseTypeComponent from "./ResponseTypeComponent";
import { AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import ViewImageDialog from "../dialogs/ViewImageDialog";
import { getMomentDateTime } from "../constants/constants";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: 5,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  questionItem: any;
  itemKey: any;
  handleOnMenuItemClicked: any;
}
class DisplayItemComponent extends React.Component<Props> {
  state = {
    anchorEl: null,
    open: false,
    photos: Array<any>(),
    openViewImage: false,
    selectImageToView: {},
  };
  handleClick = (event: any) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: true,
    });
  };
  handleClose = () => {
    this.setState({ anchorEl: null, open: false, openViewImage: false });
  };
  getResponseTypeIcon = (typeKey: any, questionValue: any) => {
    switch (typeKey) {
      case "CHECK":
        return (
          <div
            style={{
              display: "flex",
              marginRight: 20,
              backgroundColor: "red",
              flexDirection: "row",
            }}
          >
            {questionValue.response === "CHECKED" && (
              <CheckIcon style={{ margin: 5 }} fontSize={"small"} />
            )}
            {questionValue.response === "UNCHECKED" && (
              <CrossIcon style={{ margin: 5 }} fontSize={"small"} />
            )}
          </div>
        );
      case "TEXT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {questionValue.response === "HAPPY" && (
              <YESMoodGoodIcon style={{ margin: 5 }} fontSize={"small"} />
            )}
            {questionValue.response === "SAD" && (
              <NOMoodBadIcon style={{ margin: 5 }} fontSize={"small"} />
            )}
          </div>
        );

      case "COMMENT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <CommentIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );
      case "INTERACTIVE_1":
        return (
          <div
            style={{
              marginRight: 20,
              display: "flex",
              flexDirection: "row",
            }}
          >
            {questionValue.response === "OK" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: "green" }}
                fontSize={"small"}
              />
            )}
            {questionValue.response === "NOT" && (
              <ThumbsDownIcon
                style={{ margin: 5, color: "red" }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "INTERACTIVE_2":
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              flexDirection: "row",
            }}
          >
            {questionValue.response === "OK" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: "green" }}
                fontSize={"small"}
              />
            )}
            {questionValue.response === "RIGHT" && (
              <img
                alt={"interactive_right_thumb"}
                width={25}
                height={25}
                style={{ marginRight: 20, color: "orange" }}
                src={pointRightFinger}
              />
            )}
          </div>
        );
      case "NUMERIC":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <DigitsIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );
    }
  };
  getResponseType = (response: any) => {
    switch (response) {
      case "YES":
        return "GO";
      case "NOT":
        return "NO GO";
      case "RIGHT":
        return "GO-BUT";
      case "SAD":
        return "NO";
      case "HAPPY":
        return "YES";
      default: {
        return "COMMENT";
      }
    }
  };
  getBase64 = (photoId: any) => {
    let base64 = "";
    this.state.photos.map((photoItem: any) => {
      if (photoId === photoItem.photoId) {
        base64 = photoItem.base64;
      }
      return null;
    });
    return base64;
  };

  openMenu = (option: any, questionItem: any) => {
    const { handleOnMenuItemClicked } = this.props;
    this.handleClose();
    handleOnMenuItemClicked(option, questionItem);
  };

  renderViewImageDialog = () => {
    return (
      <ViewImageDialog
        open={this.state.openViewImage}
        dialogTitle={"Viewing full image"}
        imageItem={this.state.selectImageToView}
        onClose={this.handleClose}
      />
    );
  };

  render() {
    const { questionItem, itemKey, classes } = this.props;
    return (
      <React.Fragment key={itemKey.toString()}>
        {this.renderViewImageDialog()}
        <AuthConsumer>
          {({ user, accessRules }) => (
            <ListItem>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  boxShadow={1}
                  style={{
                    margin: 0,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  {/* {questionItem.legend && (
                    <Avatar
                      style={{
                        marginLeft: 10,
                        backgroundColor: `${questionItem.legend.inputColor}`,
                        color: `${questionItem.legend.textColor}`,
                      }}
                    >
                      {questionItem.legend.legendCode}
                    </Avatar>
                  )} */}
                  <ListItemText
                    style={{ marginLeft: 10 }}
                    primary={"Question"}
                    secondary={questionItem.question}
                  />
                  <Grid container item xs={6} justify="center" direction="row">
                    <Grid item xs={9}>
                      {questionItem.hasOptions ? (
                        <div>
                          <Typography>{"Response"}</Typography>
                          {questionItem.questionOptions &&
                            questionItem.value &&
                            questionItem.value.options &&
                            questionItem.value.options.map(
                              (questionOption: any, index: any) => (
                                <Chip
                                  key={"chi-" + index.toString()}
                                  style={{ marginTop: 5, marginBottom: 10 }}
                                  label={questionOption.label}
                                />
                              )
                            )}
                        </div>
                      ) : (
                        <ListItemText
                          primary={"Response"}
                          secondary={
                            questionItem.value.response
                              ? questionItem.value.response
                              : questionItem.value.numValue
                          }
                        />
                      )}
                    </Grid>
                    <Grid
                      container
                      item
                      xs={3}
                      justify="center"
                      style={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      {
                        <ResponseTypeComponent
                          feedBack={true}
                          typeKey={questionItem.responseType.title}
                          responseType={questionItem.responseType}
                          questionItem={questionItem}
                        />
                      }
                      <HasPermission
                        role={user.role}
                        accessRules={accessRules}
                        perform="company-completed:edit"
                        data={user.role}
                        yes={() => (
                          <div>
                            <IconButton
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={this.handleClick}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              id="long-menu"
                              anchorEl={this.state.anchorEl}
                              keepMounted
                              open={this.state.open}
                              onClose={this.handleClose}
                              PaperProps={{
                                style: {
                                  maxHeight: 48 * 4.5,
                                  width: "20ch",
                                },
                              }}
                            >
                              {["Edit"].map((option) => (
                                <MenuItem
                                  key={option}
                                  selected={option === "Edit"}
                                  onClick={() =>
                                    this.openMenu(option, questionItem)
                                  }
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </Menu>
                          </div>
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
                {questionItem.value && questionItem.value.timeCaptured && (
                  <Accordion
                    square={false}
                    elevation={0}
                    expanded={true}
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    <AccordionDetails
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                      }}
                    >
                      <ListItemText
                        primary={"Time Captured"}
                        secondary={getMomentDateTime(
                          questionItem.value.timeCaptured
                        )}
                      />
                    </AccordionDetails>
                  </Accordion>
                )}
                {questionItem.value && questionItem.value.notes && (
                  <Accordion
                    square={false}
                    elevation={0}
                    expanded={true}
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography className={classes.heading}>
                          Comments
                        </Typography>
                        <Typography style={{ whiteSpace: "pre-line" }}>
                          {questionItem.value.notes}
                        </Typography>
                      </div>
                    </AccordionSummary>
                  </Accordion>
                )}
                {questionItem.value &&
                  questionItem.value.images &&
                  questionItem.value.images.length > 0 && (
                    <Accordion
                      square={false}
                      elevation={0}
                      expanded={true}
                      style={{ backgroundColor: "#fafafa" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading}>
                          View Images...
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                      >
                        <List
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            padding: 0,
                          }}
                        >
                          {questionItem.value.images.map(
                            (imageItem: any, index: any) => (
                              <ButtonBase
                                key={index.toString()}
                                style={{ width: 80, height: 80, margin: 5 }}
                                onClick={() => {
                                  this.setState({
                                    selectImageToView: imageItem,
                                    openViewImage: true,
                                  });
                                }}
                              >
                                {imageItem.base64 ? (
                                  <img
                                    src={`data:image/jpeg;base64,${imageItem.base64}`}
                                    alt={index.toString()}
                                    style={{ width: 80, height: 80, margin: 5 }}
                                  />
                                ) : (
                                  <img
                                    src={imagePlacholder}
                                    alt={index.toString()}
                                    style={{ width: 80, height: 80, margin: 5 }}
                                  />
                                )}
                              </ButtonBase>
                            )
                          )}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  )}
              </div>
            </ListItem>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(DisplayItemComponent);
